import React from 'react';
import PaperContainer from './PaperContainer';
import { Box, Grid, Typography } from '@mui/material';
import { ReactComponent as SignoutIcon } from '../images/logout_icon.svg';
import { simplifiedAuthStyles } from '../styles/simplifiedAuth';
import { useTranslation } from 'react-i18next';
import { getCookie } from '../../common/utils/cookies';
import { StaticPageIconStyles } from '../../common/styles/staticPageIcon';

const LogOutPage = (): React.JSX.Element => {
  const { classes } = simplifiedAuthStyles();
  const { classes: StaticPageIconClasses } = StaticPageIconStyles();
  const { t } = useTranslation();
  const isBasicFlow = getCookie('BasicFlow') === '1';
  return (
    <PaperContainer variant="medium">
      <Grid container justifyContent="center">
        <Box textAlign="center" className={classes.signOut}>
          {isBasicFlow && <SignoutIcon width="120px" height="120px" className={StaticPageIconClasses.staticPageIcon} />}
          <Typography variant="h1" className={classes.marginBottom15}>
            {t('simplifiedSignOut')}
          </Typography>
          <Typography>{t('simplifiedSignOutText1')}</Typography>
          <Typography>{t('simplifiedSignOutText2')}</Typography>
        </Box>
      </Grid>
    </PaperContainer>
  );
};
export default LogOutPage;
